// extracted by mini-css-extract-plugin
export default {"input":"Input_input__WklOd","editor":"Input_editor__DW2vA","controls":"Input_controls__7kozs"};